import { render, staticRenderFns } from "./SumupTab.vue?vue&type=template&id=74f00fad&"
import script from "./SumupTab.vue?vue&type=script&lang=ts&"
export * from "./SumupTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports